import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { Switch, Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import styles from "../constants/styles";

const RBISwitch = ({ name, label, defaultValue = false, disabled = false }) => {
  const classes = styles();
  const { control } = useFormContext();
  return (
    <div className={classes.alignCenterSpaceBetween} style={{ width: '100%' }}>
      <Typography>{label}</Typography>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={props => (
          <div className={classes.gridEditButton}>
            <CloseIcon />
            <Switch
              onChange={e => props.onChange(e.target.checked)}
              checked={props.value}
              disabled={disabled}
            />
            <CheckIcon />
          </div>
        )}
      />
    </div>
  );
};

export default RBISwitch;
